/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
export const EnumInflowSource = {
    Email: 'email',
    PublicLink: 'public_link'
};
export function EnumInflowSourceFromJSON(json) {
    return EnumInflowSourceFromJSONTyped(json, false);
}
export function EnumInflowSourceFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function EnumInflowSourceToJSON(value) {
    return value;
}
